/** Build a media URL for a payload file path (strips the "payloads/" prefix). */
export function fileUrl(path: string): string {
  if (path.startsWith("http")) return path;
  return `/api/get_file/${path.replace(/^payloads\//, "").replace(/^\/+/, "")}`;
}
